<template>
    <div id="main">
        <Breadcrumb :currentPage="breadcrumbName" :items="breadcrumbItems" :showAddBtn="false"/>
        <Dialog ref="ratingDialog"/>
        <!--Upload partition-->
        <v-layout row wrap>
            <v-flex order-lg1 order-md1 order-xs1 d-flex xs12 sm6 md4>
                <!--Upload card-->
                <v-layout row wrap>
                    <v-flex d-flex>
                        <v-card class="mx-auto upload">
                            <v-card-title>
                                <b>Upload Image</b>
                                <svg style="width:24px;height:24px;margin-left:5px" viewBox="0 0 24 24">
                                    <path
                                        fill="#3b547d"
                                        d="M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16"
                                    />
                                </svg>
                            </v-card-title>

                            <v-card-text>
                                <span class="dot"></span>Supported categories: Plane, Bench, Cabinet, Car, Chair,
                                Monitor,
                                Lamp, Speaker, Firearm, Couch, Table, Cellphone, Watercraft, Mug
                            </v-card-text>
                            <UploadImage :images="selectedImages" @update="onImageUpdate"/>
                            <v-card-actions>
                                <div style="width: 100%">
                                    <v-btn
                                        @click="generate(selectedImages)"
                                        color="primary"
                                        style="width: 40%"
                                    >Generate
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                    <v-flex d-flex v-if="visibleRating">
                        <!--Rating card-->
                        <v-card class="mx-auto" >
                            <v-card-title>
                                <b>Rating</b>
                            </v-card-title>
                            <v-card-actions>
                                <v-form v-model="valid" style="width: 100%">
                                    <v-container>
                                        <v-rating
                                            v-model="rating"
                                            style="margin-top: -10%"
                                            background-color="orange lighten-3"
                                            color="orange"
                                        ></v-rating>
                                        <v-text-field v-model="comment" label="Type your comment" single-line
                                                      solo></v-text-field>
                                        <v-btn
                                            @click="submitRating"
                                            color="primary"
                                            style="display: inline-flex; width: 5%"
                                        >
                                            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                                <path
                                                    fill="#ffffff"
                                                    d="M9.78,18.65L10.06,14.42L17.74,7.5C18.08,7.19 17.67,7.04 17.22,7.31L7.74,13.3L3.64,12C2.76,11.75 2.75,11.14 3.84,10.7L19.81,4.54C20.54,4.21 21.24,4.72 20.96,5.84L18.24,18.65C18.05,19.56 17.5,19.78 16.74,19.36L12.6,16.3L10.61,18.23C10.38,18.46 10.19,18.65 9.78,18.65Z"
                                                />
                                            </svg>
                                        </v-btn>
                                    </v-container>
                                </v-form>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex order-lg2 order-md2 order-xs2 d-flex md8>
                <v-card class="mx-auto module-3ds">
                    <v-card-title>
                        <b>Module 3D</b>
                    </v-card-title>
                    <div v-if="disclaimer" class="disclaimer">
                        <img :src="icon">
                        <div class="disclaimer-content">
                            <p>Model results may not be good</p>
                            <p>because the image is not up to standard</p>
                        </div>
                    </div>
                    <Viewer3d :mesh="meshFile" class="viewer-3d"/>
                    <p v-if="disclaimer" class="drag-spin">Drag to spin the model</p>
                </v-card>
            </v-flex>
        </v-layout>

    </div>
</template>

<script>
    import axios from "axios";
    import Const from "../const.js";
    import Breadcrumb from '../components/common/Breadcrumb.vue';
    import Dialog from '../components/common/Dialog.vue';
    import UploadImage from "../components/UploadImage.vue";
    import Viewer3d from "../components/Viewer3d.vue";
    import { mapActions } from 'vuex'

    export default {
        name: "upload",
        data() {
            return {
                breadcrumbName: "Upload",
                breadcrumbItems: [
                    {
                        text: "Upload",
                        disabled: true,
                        to: {path: "/upload"},
                        exact: true
                    }
                ],
                visibleRating: false,
                rating: 0,
                comment: "",
                valid: false,
                meshId: "",
                meshFile: "",
                selectedImages: [],
                errors: [],
                icon: require('../assets/disclamer.svg'),
                disclaimer: false,
            };
        },
        components: {
            Breadcrumb,
            Dialog,
            UploadImage,
            Viewer3d
        },
        methods: {
            ...mapActions('app',[
                'showDialogNotification'
            ]),
            onImageUpdate(newImages) {
                this.selectedImages = newImages;
            },
            submitRating: function () {
                if (this.valid === true) {
                    this.$root.$dialogLoader.start("Submiting ...", {color: "primary"}, {}, true);
                    axios
                        .post(Const.SERVER_ADDR + "debuglog/rating", {
                            mesh_id: this.meshId,
                            rate: this.rating,
                            comment: this.comment,
                        })
                        .then(response => {
                            // Show message response.data.title + response.data.message
                            this.$refs.ratingDialog.dialogShow = true;
                            this.$refs.ratingDialog.title = response.data.title;
                            this.$refs.ratingDialog.message = response.data.message;
                            this.$root.$dialogLoader.stop("3D model generated", {timeout: 10000}, {});
                        })
                        .catch(e => {
                            this.$root.$dialogLoader.stop("Error", {timeout: 10000}, {});
                            this.errors.push(e);
                        });
                }
            },

            generate: function (selectedImgs) {
                var imgsData = selectedImgs.map(img => img.path.split(",")[1]);
                // this.visibleRating = true;
                // this.$root.$dialogLoader.stop(
                //   "3D model generated",
                //   { timeout: 10000 },
                //   {}
                // );
                if (imgsData.length === 0) {
                    return this.showDialogNotification('You should select image');
                } else {
                    this.visibleRating = false;

                    this.$root.$dialogLoader.start(
                        "Generating ...",
                        {color: "primary"},
                        {},
                        true
                    );
                    axios
                        .post(Const.SERVER_ADDR + "mesh/create", {
                            body: imgsData
                        })
                        .then(response => {
                            this.meshId = response.data.mesh_id;
                            this.meshFile = Const.SERVER_ADDR + response.data.mesh_url;
                            this.visibleRating = true;
                            this.$root.$dialogLoader.stop(
                                "3D model generated",
                                {timeout: 10000},
                                {}
                            );
                            this.disclaimer = true
                        })
                        .catch(e => {
                            this.$root.$dialogLoader.stop("Error", {timeout: 10000}, {});
                            this.errors.push(e);
                        });
                }

            }
        }
    };
</script>

<style scoped>
    .dot {
        height: 10px;
        width: 10px;
        background-color: #0000cc;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
    }

    .upload,
    .module-3ds {
        min-height: 60vh;

    }
    .disclaimer {
        margin-left: 0;
        padding-left: 16px;
        display: flex;
    }

    .disclaimer img {
        margin-left: 0;
        float: left;
    }

    .disclaimer-content p {
        margin-bottom: 0;
        text-align: left;
        color: #FF9F43;
        font-weight: 600;
        font-size: 0.8rem;
    }
    .viewer-3d{
        margin-top: 15%;
        height: 70%;
    }

</style>
